// extracted by mini-css-extract-plugin
export default {"formActions":"UpsertRecipeForm_formActions__v7eNg"};